class MiniCart extends HTMLElement{
    constructor(){
        super();
        this.cartList = this.getElementsByClassName('mini-cart__list')[0]; 

        this.closeBtn = this.getElementsByClassName('mini-cart__close')[0];
        this.closeBtn.addEventListener('click', this.closeMiniCart.bind(this));

        this.itemClose = this.getElementsByClassName('mini-cart__item-close');
        
        Array.from(this.itemClose).forEach(function(btn){
            btn.addEventListener('click', this.removeItem.bind(this));
        }, this);
        
        this.total = this.getElementsByClassName('mini-cart__total-value')[0];
        this.bubbles = document.getElementsByClassName('cart-link__bubble');

        this.overlay = this.getElementsByClassName('loading-dual-ring-container')[0];

        // window.addEventListener('cartUpdate', this.getCurrentCart.bind(this));

        this.setPositionMiniCart();
        window.addEventListener('resize', this.setPositionMiniCart.bind(this));
        window.addEventListener('scroll', this.setPositionMiniCart.bind(this));
        window.addEventListener('wheel', this.setPositionMiniCart.bind(this));
    }
    getCurrentCart() {
        this.overlay.style.display = 'flex';
        let cartData = theme.cart.getCart();
        cartData.then(function(cart) {
            this.buildMiniCart(cart);
            if(!document.getElementsByTagName('body')[0].classList.contains('template-cart')) {
                this.overlay.style.display = 'none';
                this.classList.add('show');
                let product_swiper = document.querySelector('.template-product .pswp');
               
                if(product_swiper != undefined && product_swiper.classList.contains('pswp--open')) {
                    product_swiper.classList.remove('pswp--open');
                }
                
            }
        }.bind(this));
    }
    buildMiniCart(cart) {
        while (this.cartList.firstChild) this.cartList.removeChild(this.cartList.firstChild);
        let items = cart.items;
        let itemsHtml = '';
        for(let i = 0; i < items.length; i++) {
            let itemHtml = this.buildItem(items[i]);
            this.cartList.append(itemHtml);
        }
        this.updatePrice(cart);
    }
    buildItem(item) {
        let item_element = document.createElement('div');
        item_element.classList.add('mini-cart__item');
        item_element.dataset.variant = item.variant_id;

        let item_total = item.original_price * item.quantity;
        let html =  '<a href="' + item.url + '" class="mini-cart__item-image">'
                        + '<img src="' + item.image + '">'
                    + '</a>'
                    + '<div class="mini-cart__item-title">'
                        + item.title
                    + '</div>'
                    + '<div class="mini-cart__item-price">'
                        + '<span class="cart__price"><div class="pn-price-item" data-id="' + item.id + '">' + theme.Currency.formatMoney(item_total, theme.settings.moneyFormat) + '</div></span>'
                    + '</div>';
        if(parseFloat(item.quantity) > 1) {
            let new_title = item.title + ' <strong>x' + item.quantity + '</strong>';
            html = html.replaceAll(item.title, new_title);
        }
        item_element.innerHTML = html;

        let close_element = document.createElement('a');
        close_element.classList.add('mini-cart__item-close');
        close_element.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg>';
        close_element.addEventListener('click', this.removeItem.bind(this));

        item_element.append(close_element);
        
        
        return item_element;
    }
    removeItem(e) {
        e.preventDefault();
        
        let item = e.target.closest('a').parentElement;
        console.log(item);
        let variant_id = item.dataset.variant;
        let qty = 0;
        
        theme.cart.changeItem(variant_id, qty);
        
    }
    closeMiniCart(e) {
        e.preventDefault();
        if(this.classList.contains('show')) {
            this.classList.remove('show');
        }
    }
    updatePrice(cart) {
        this.total.innerText = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat);
        this.updateCartBubble(cart.item_count);
    }
    updateCartBubble(count) {
        Array.from(this.bubbles).forEach(function(bubble){
            if(count > 0) {
                bubble.innerText = count;
                if(!bubble.classList.contains('cart-link__bubble--visible')) {
                    bubble.classList.add('cart-link__bubble--visible');
                }
            }
            else if(bubble.classList.contains('cart-link__bubble--visible')) {
                bubble.classList.remove('cart-link__bubble--visible');
            }
        });
        // this.bubble.innerText = count;
    }
    setPositionMiniCart() {
        let header = document.getElementById('shopify-section-header');
        let container_height = document.querySelector('.site-header--heading-style .page-width').offsetHeight;
        
        if(window.innerWidth > 768 && !this.classList.contains('hide-header')) {
            this.style.top = (container_height + 2) + 'px';
        }else if (this.classList.contains('hide-header')) {
            this.style.top = (header.offsetHeight - 19) + 'px';
        }
    }
  }
customElements.define("mini-cart", MiniCart); 